import { z } from 'zod/v4';

/** A user assigned a development tag, as the admin tags page lists them. */
export const AdminDevelopmentTagUserSchema = z.object({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  /** The user's primary company; `null` when it no longer resolves. */
  companyId: z.string().nullable(),
  companyName: z.string().nullable(),
});

export type AdminDevelopmentTagUser = z.infer<
  typeof AdminDevelopmentTagUserSchema
>;

/**
 * One development tag with the users who hold it. Always the three tags, in
 * hierarchy order (`EXPERIMENTAL`, `ALPHA`, `BETA`), whether or not anyone
 * holds them. Legacy sent every column of each user; the page reads only these.
 */
export const AdminDevelopmentTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  enabledUsers: z.array(AdminDevelopmentTagUserSchema),
});

export type AdminDevelopmentTag = z.infer<typeof AdminDevelopmentTagSchema>;

// Not paginated: the list is the three tags. Legacy wrapped it in a paginated
// `{ data, meta }` envelope that always described one page of three.
export const AdminDevelopmentTagsResponseSchema = z.object({
  metadata: z.object({ success: z.boolean() }),
  data: z.array(AdminDevelopmentTagSchema),
});

export type AdminDevelopmentTagsResponse = z.infer<
  typeof AdminDevelopmentTagsResponseSchema
>;
